import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';
import './Pagination.css';

export default function Pagination({ page, totalPages, onPageChange }) {
  if (totalPages <= 1) return null;

  const pages = [];
  const maxVisible = 5;
  let start = Math.max(1, page - Math.floor(maxVisible / 2));
  let end = Math.min(totalPages, start + maxVisible - 1);
  if (end - start < maxVisible - 1) {
    start = Math.max(1, end - maxVisible + 1);
  }

  for (let i = start; i <= end; i++) {
    pages.push(i);
  }

  return (
    <div className="pagination">
      <button className="pagination-btn" disabled={page <= 1}
        onClick={() => onPageChange(page - 1)}>
        <ChevronLeft size={16} />
      </button>

      {start > 1 && (
        <>
          <button className="pagination-num" onClick={() => onPageChange(1)}>1</button>
          {start > 2 && <span className="pagination-dots">…</span>}
        </>
      )}

      {pages.map((p) => (
        <button key={p}
          className={`pagination-num ${p === page ? 'active' : ''}`}
          onClick={() => onPageChange(p)}>
          {p}
        </button>
      ))}

      {end < totalPages && (
        <>
          {end < totalPages - 1 && <span className="pagination-dots">…</span>}
          <button className="pagination-num" onClick={() => onPageChange(totalPages)}>{totalPages}</button>
        </>
      )}

      <button className="pagination-btn" disabled={page >= totalPages}
        onClick={() => onPageChange(page + 1)}>
        <ChevronRight size={16} />
      </button>
    </div>
  );
}